import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import Const from 'constants';
import NumberHelper from 'helpers/number-helper';
import InputText from 'components/atoms/inputs/input-text';

class FlexMaxExpPositions extends Component {
    constructor(props) {
        super(props);

        this.flexPositionName = props.flexPositionName || Const.POSITION_FLEX;

        const baseState = this.getBaseState(props);
        if (baseState) {
            this.state = baseState;
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {flexMaxExposurePositions} = this.props;
        const {flexMaxExposurePositions: prevFlexMaxExposurePositions} = prevProps;

        const shouldStateBeUpdated = (!isEmpty(flexMaxExposurePositions) && isEmpty(prevFlexMaxExposurePositions)) || 
            (!isEmpty(prevFlexMaxExposurePositions) && isEmpty(flexMaxExposurePositions));

        if (shouldStateBeUpdated) {
            const baseState = this.getBaseState(this.props);
            if (baseState) {
                this.setState(baseState);
            }
        }
    }

    getBaseState(props) {
        const {sportConfig, flexMaxExposurePositions} = props;
        const flexPositions = sportConfig.getConfigProp('flexPlayerPosition');
        const positions = sportConfig.getConfigProp('positions');

        if (!positions.hasOwnProperty(flexPositions[this.flexPositionName])) {
            return null;
        }

        const flexPosition = positions[flexPositions[this.flexPositionName]];

        const state = {};

        Object.keys(flexPosition.allowedPositions).map((key) => {
            let defaultValue = Const.DEFAULT_VALUE_FOR_MAX_EXPOSURE;
            let positionNumber = flexPosition.allowedPositions[key];
            if (!positions.hasOwnProperty(positionNumber)) {
                return;
            }

            let position = positions[positionNumber];
            if (!isEmpty(flexMaxExposurePositions) && flexMaxExposurePositions.hasOwnProperty(position.shortName)) {
                defaultValue = flexMaxExposurePositions[position.shortName];
            }

            state[position.shortName] = defaultValue;
        });

        return state;
    }

    onChange(position, e) {
        this.setState({
            [position]: e.target.value,
        });
    }

    onBlur(position, value) {
        value = NumberHelper.prepareInt(value, Const.DEFAULT_VALUE_FOR_MAX_EXPOSURE)
            .limitByRange(0, Const.DEFAULT_VALUE_FOR_MAX_EXPOSURE, Const.DEFAULT_VALUE_FOR_MAX_EXPOSURE)
            .get();

        this.setState({
            [position]: value,
        });

        this.props.dispatch(
            Action.set('FlexMaxExposurePositions', {
                [position]: value,
            }),
        );
    }

    render() {
        const {sportConfig, label = 'Flex positions'} = this.props;
        let data = {...this.state};

        if (!sportConfig.hasRestrictions()) {
            return null;
        }

        return (
            <div>
                <strong className="filter-sub-title">{label}:</strong>
                <div className="form-inline">
                    {Object.keys(data).map((key) => {
                        return (
                            <div key={key} className="position-group">
                                <span className="text">{key}</span>
                                <InputText value={data[key]} percent onBlur={(value) => ::this.onBlur(key, value)} />
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        sportConfig,
        playersData: {flexMaxExposurePositions},
    } = state;

    return {
        sportConfig,
        flexMaxExposurePositions,
    };
}

export default connect(mapStatesToProps)(FlexMaxExpPositions);
